export const TEAM_CHAT_SLASH_COMMANDS = [
  {
    id: 'shrug',
    label: '/shrug',
    description: 'Append ¯\\_(ツ)_/¯ to your message',
    insertion: '¯\\_(ツ)_/¯',
  },
  {
    id: 'tableflip',
    label: '/tableflip',
    description: 'Append (╯°□°)╯︵ ┻━┻',
    insertion: '(╯°□°)╯︵ ┻━┻',
  },
  {
    id: 'unflip',
    label: '/unflip',
    description: 'Append ┬─┬ノ( º _ ºノ)',
    insertion: '┬─┬ノ( º _ ºノ)',
  },
  {
    id: 'here',
    label: '/here',
    description: 'Notify active channel members',
    insertion: '@here ',
  },
  {
    id: 'all',
    label: '/all',
    description: 'Notify everyone in this channel',
    insertion: '@all ',
  },
];
